/**
 * TableContainer Component
 * Encapsulated TableContainer with horizontal scrolling support
 */

import React from 'react';
import { TableContainer as MuiTableContainer, TableContainerProps as MuiTableContainerProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export interface TableContainerProps extends MuiTableContainerProps {
    // Inherits all MuiTableContainer props
}

export const TableContainer: React.FC<TableContainerProps> = ({
    sx,
    children,
    ...props
}) => {
    const theme = useTheme();

    return (
        <MuiTableContainer
            sx={{
                width: '100%',
                overflowX: 'auto',
                // Custom Scrollbar - matching sidebar style
                '&::-webkit-scrollbar': {
                    height: '10px',
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: theme.palette.mode === 'dark'
                        ? 'rgba(255, 255, 255, 0.2)'
                        : 'rgba(0, 0, 0, 0.2)',
                    borderRadius: '10px',
                    '&:hover': {
                        background: theme.palette.mode === 'dark'
                            ? 'rgba(255, 255, 255, 0.4)'
                            : 'rgba(0, 0, 0, 0.4)',
                    },
                },
                // Firefox
                scrollbarWidth: 'thin',
                scrollbarColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.2) transparent'
                    : 'rgba(0, 0, 0, 0.2) transparent',
                ...sx,
            }}
            {...props}
        >
            {children}
        </MuiTableContainer>
    );
};
